import { render, staticRenderFns } from "./ProductModelCreateScreen.vue?vue&type=template&id=6d66c40d&"
import script from "./ProductModelCreateScreen.vue?vue&type=script&lang=js&"
export * from "./ProductModelCreateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports